import { styled } from 'stitches.config'

export const DifferenceRoot = styled('div', {
  backgroundColor: '$secondary-100',
  color: '$primary-800',
  px: '$3',
  paddingTop: '$12',
  paddingBottom: '$11',

  '@bp2': {
    px: '$15',
  },
})

export const Flex = styled('div', {
  display: 'flex',
  flexDirection: 'column',
  alignItems: 'center',
  justifyContent: 'flex-start',
  gap: '$4',
  marginBottom: '$5',

  '@bp2': {
    flexDirection: 'row',
    alignItems: 'center',
    justifyContent: 'space-between',
    gap: '$15',
  },
})

export const ImageContainer = styled('figure', {
  order: 1,
  position: 'relative',
  maxWidth: '504px',

  '@bp2': {
    order: 2,
  },
})

export const IsologoContainer = styled('div', {
  position: 'absolute',
  zIndex: '10',
  top: '-15px',
  left: '-15px',
})

export const TitleContent = styled('div', {
  order: 2,
  textAlign: 'center',

  '@bp2': {
    order: 1,
    textAlign: 'initial',
  },
})

export const DifferenceItemsList = styled('ul', {
  display: 'flex',
  flexDirection: 'column',
  alignItems: 'center',
  justifyContent: 'flex-start',
  gap: '$5',

  '@bp2': {
    flexDirection: 'row',
    justifyContent: 'space-between',
    flexWrap: 'wrap',
  },
})
